import React, { Component } from "react";
import { Link } from "react-router-dom";
import CentromericCopyNumberAssays from "./CentromericCopyNumberAssays.jsx";
import InfectiousDiseaseAssays from "./InfectiousDiseaseAssays.jsx";
import FeaturedCellAndGeneTherapy from "./FeaturedCellAndGeneTherapy.jsx";
import AllAssaysByType from "./AllAssaysByType.jsx";
import QuickOrder from "./QuickOrder.jsx";
import * as config from "../../app.config";
import AppWrapper from "../Common/AppWrapper/index.jsx";
import VideoPlayer from "./Video-HomePage.jsx";
import "./Home.scss";

class Home extends Component {
  render() {
    return (
      <AppWrapper
        id="home"
        pageTitle="Home"
        pageDescription="Bio-Rad offers a range of design engines to help you create custom ddPCR assays including mutation detection, gene expression, copy number determination, genome edit detection and cell and gene therapy"
        pageKeywords="Droplet Digital PCR, ddPCR, design engine, custom assay, mutation detection, gene expression, copy number determination, genome edit detection and cell and gene therapy"
      >
        <div id="home-inner">
          <div id="section1">
            <div className="row">
              <div className="col-md-7 align-self-center">
                <h1>Find and Buy Your Assay</h1>
                <div className="lead-copy">
                  <p>
                    Get the most out of your experiment with assays designed
                    specifically for Droplet Digital PCR.
                  </p>
                  <p>
                    Choose your application, enter your target and let our tool
                    find the right assay for you.
                  </p>
                </div>

                <div className="row">
                  <div className="col-md-4">
                    <Link
                      to="/digital-assays/assays-create/mutation"
                      className="btn-app mut"
                      data-cy="MutationDetection"
                    >
                      <span>
                        Mutation
                        <br />
                        Detection
                      </span>
                    </Link>
                  </div>
                  <div className="col-md-4">
                    <Link
                      to="/digital-assays/assays-create/gene-expression"
                      className="btn-app ge"
                    >
                      <span>
                        Gene
                        <br />
                        Expression
                      </span>
                    </Link>
                  </div>
                  <div className="col-md-4">
                    <Link
                      to="/digital-assays/assays-create/cnd"
                      className="btn-app cnd"
                    >
                      <span>
                        Copy Number
                        <br />
                        Determination
                      </span>
                    </Link>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-4">
                    <Link
                      to="/digital-assays/assays-create/genome"
                      className="btn-app ge"
                    >
                      <span>
                        Genome Edit
                        <br />
                        Detection
                      </span>
                    </Link>
                  </div>
                  <div className="col-md-4">
                    <Link
                      to="/digital-assays/assays-create/cell-and-gene-therapy"
                      className="btn-app cgt"
                    >
                      <span>
                        Cell and Gene
                        <br />
                        Therapy
                      </span>
                    </Link>
                  </div>
                </div>
              </div>
              <div className="col-md-5">
                <div className="d-none d-md-block">
                  <VideoPlayer />
                </div>
              </div>
            </div>
          </div>
          {/*section1 end*/}

          <div id="section2">
            <div id="featured-content">
              <div className="row">
                <div className="col text-center">
                  <h2>Browse Curated Lists</h2>
                </div>
              </div>

              <div className="row">
                <div className="col-md-4">
                  <div className="featured-item">
                    <InfectiousDiseaseAssays />
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="featured-item">
                    <FeaturedCellAndGeneTherapy />
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="featured-item">
                    <CentromericCopyNumberAssays />
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12 bdr">
                <QuickOrder />
              </div>
            </div>
          </div>
        </div>
      </AppWrapper>
    );
  }
}

export default Home;
